import { isEmpty } from 'lodash';
import {
  getPerformanceMetrics,
  getRevenueMetrics,
} from 'modules/iterableGoals/utils/goalAnalytics';
import { ActionTypes } from '../actionTypes';
import { GoalPerformanceAction, GoalPerformanceState } from '../../types';

export const initialState = {
  metrics: {},
  previousMetrics: {},
  revenue: {},
  previousRevenue: {},
  loading: true,
  error: false,
};

export const goalPerformanceReducer = (
  state: GoalPerformanceState = initialState,
  action?: GoalPerformanceAction,
) => {
  const metrics = action?.payload?.metrics;
  const hasData = !isEmpty(metrics);
  const previousMetrics = action?.payload?.previousMetrics;
  const hasPreviousData = !isEmpty(previousMetrics);
  const metricsData = {
    metrics: state.metrics,
    revenue: state.revenue,
  };
  const previousMetricsData = {
    previousMetrics: state.previousMetrics,
    previousRevenue: state.previousRevenue,
  };

  if (metrics && hasData) {
    metricsData.metrics = getPerformanceMetrics(metrics);
    metricsData.revenue = getRevenueMetrics(metrics);
  }

  if (previousMetrics && hasPreviousData) {
    previousMetricsData.previousMetrics = getPerformanceMetrics(previousMetrics);
    previousMetricsData.previousRevenue = getRevenueMetrics(previousMetrics);
  }

  switch (action?.type) {
    case ActionTypes.FETCH_GOAL_PERFORMANCE_REQUEST:
    case ActionTypes.FETCH_GOAL_ANALYTICS_REQUEST:
      return {
        ...state,
        error: false,
        loading: true,
      };
    case ActionTypes.FETCH_GOAL_PERFORMANCE_RESPONSE:
      return {
        ...state,
        error: false,
        metrics: action?.payload,
        loading: false,
      };
    case ActionTypes.FETCH_GOAL_ANALYTICS_RESPONSE:
      return {
        ...state,
        ...previousMetricsData,
        ...metricsData,
        error: false,
        loading: false,
      };
    case ActionTypes.FETCH_GOAL_PERFORMANCE_ERROR:
    case ActionTypes.FETCH_GOAL_ANALYTICS_ERROR:
      return {
        ...initialState,
        error: true,
        loading: false,
      };
    default:
      return state;
  }
};
